var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBaUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 18.3334C15.1027 18.3334 18.8337 14.6025 18.8337 10.0001C18.8337 5.39771 15.1027 1.66675 10.5003 1.66675C5.89795 1.66675 2.16699 5.39771 2.16699 10.0001C2.16699 14.6025 5.89795 18.3334 10.5003 18.3334Z",
    stroke: "#98A2B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBaUnchecked);
export default __webpack_public_path__ + "static/media/icon-ba-unchecked.64f026653f03a2574b1d4a816ecca6e9.svg";
export { ForwardRef as ReactComponent };